import { gql } from 'apollo'
import { ReadWorkerData } from 'components/WorkerPersona/typings/ReadWorkerData'
import {
  Persona,
  PersonaInitialsColor,
  PersonaSize,
} from 'office-ui-fabric-react'
import {
  Shimmer,
  ShimmerElementsGroup,
  ShimmerElementType,
} from 'office-ui-fabric-react/lib/Shimmer'
import * as React from 'react'
import { useQuery } from 'react-apollo-hooks'
import { ReadUserData } from './typings/ReadUserData'

export const READ_USER_DATA = gql`
  query ReadUserData($_id: String!) {
    user(id: $_id) {
      id
      name
      department
      email
      roles
    }
  }
`

export const READ_WORKER_DATA = gql`
  query ReadWorkers($_id: String) {
    workers(filter: { _id: { EQ: $_id } }) {
      _id
      firstName
      lastName
      department
      company
      pid
    }
  }
`

export interface AsyncUserPersonaProps {
  id: string
  size?: PersonaSize
  type?: string
}

const getCustomElementsExampleTwo = (): JSX.Element => {
  return (
    <div
      // tslint:disable-next-line:jsx-ban-props
      style={{ display: 'flex' }}
    >
      <ShimmerElementsGroup
        shimmerElements={[
          { type: ShimmerElementType.circle, height: 40 },
          { type: ShimmerElementType.gap, width: 10, height: 40 },
        ]}
      />
      <ShimmerElementsGroup
        flexWrap={true}
        shimmerElements={[
          { type: ShimmerElementType.line, width: 100, height: 10 },
          { type: ShimmerElementType.gap, width: 100, height: 20 },
          { type: ShimmerElementType.line, width: 200, height: 10 },
        ]}
      />
    </div>
  )
}

const resolveUserProperties = (data: any) => {
  if (data === undefined) {
    return null
  } else if (data.user) {
    return {
      text: data.user.name,
      secondaryText: data.user.email,
      tertiaryText: data.user.department,
    }
  } else if (data.workers) {
    return {
      text: `${data.workers[0].lastName}, ${data.workers[0].firstName}`,
      secondaryText: data.workers[0].department,
      tertiaryText: data.workers[0].company,
    }
  } else {
    return undefined
  }
}

export const AsyncUserPersona: React.FunctionComponent<
  AsyncUserPersonaProps
> = ({ id, type, size = PersonaSize.regular, ...props }) => {
  const userData = useQuery<ReadUserData>(READ_USER_DATA, {
    variables: { _id: id },
  })

  const workerData = useQuery<ReadWorkerData>(READ_WORKER_DATA, {
    variables: { _id: id },
  })

  const { data } = userData!.data!.user !== null ? userData : workerData

  const user = resolveUserProperties(data)

  if (user) {
    return (
      <Persona
        text={user.text}
        initialsColor={PersonaInitialsColor.lightRed}
        secondaryText={user.secondaryText}
        tertiaryText={user.tertiaryText!}
        size={size}
        {...props}
      />
    )
  } else {
    return (
      <Shimmer
        customElementsGroup={getCustomElementsExampleTwo()}
        width={'80%'}
      />
    )
  }
}

export default AsyncUserPersona
